export type SpaceTeamColorOptions = {
    administrativeColor?: string;
    technicalColor?: string;
    mobileColor?: string;
    gradientDirection?: string;
};
export const getSpaceColor = (
    spaceTeams: string[] | null | undefined,
    options?: SpaceTeamColorOptions,
): string | null => {
    const {
        administrativeColor = '#ffe8a4',
        technicalColor = '#a4c1ec',
        mobileColor = '#90ee90',
        gradientDirection = 'to bottom',
    } = options || {};
    if (!spaceTeams?.length) return null;
    const hasAdministrative = spaceTeams.includes('Administrative');
    const hasTechnical = spaceTeams.includes('Technical');
    const hasMobile = spaceTeams.includes('Mobile');

    const teamColors = [];
    if (hasAdministrative) teamColors.push(administrativeColor);
    if (hasTechnical) teamColors.push(technicalColor);
    if (hasMobile) teamColors.push(mobileColor);

    if (teamColors.length === 0) return null;
    if (teamColors.length === 1) return teamColors[0];

    const segmentSize = 100 / teamColors.length;
    const gradientParts = teamColors
        .map(
            (color, index) =>
                `${color} ${index * segmentSize}%, ${color} ${(index + 1) * segmentSize}%`,
        )
        .join(', ');

    return `linear-gradient(${gradientDirection}, ${gradientParts})`;
};
